
@for (color of colorConfigList; track $index) {
    <div class="color-block line-chart">
        @if (!color.lineChartCustomConfig) {
            <label>{{ color.attributeValue }}</label>
        } @else {
            <div class="add-custom-row">
                <input
                    class="formControl"
                    type="text"
                    autocomplete="off"
                    maxlength="50"
                    name="customAttribute"
                    [(ngModel)]="color.attributeValue"/>

                <button class="empty-btn" type="button" (click)="addLineChartCustomAttributeValue($index)">Add</button>
            </div>
        }

        <ddv-multi-color-picker
            [colorValues]="colorValues"
            [backgroundStyle]="color.attributeColorName"
            [dropdownClass]="dropdownClass"
            [isReadOnly]="isReadOnly"
            (colorSelected)="onColorSelected($event, $index)"
        >
        </ddv-multi-color-picker>
    </div>
}

<div class="color-block custom-style">
    <div class="add-custom-style">
        <cc-icon
            class="add-visualization-icon"
            [icon]="'plus-circle'"
            [size]="'xsmall'"
            [disabled]="isReadOnly"
            (iconClicked)="addAdditionalLineChartColor()">
        </cc-icon>
        <span [ngClass]="{'readonly': isReadOnly}">Add</span>
    </div>
</div>
